import { useEffect, useState } from 'react';
import api from '../../../../utils/api';
import { EnterpriseEndpoints } from '../../../../utils/endpoints';
import { Permissions } from '../../../../utils/permissions';
import { useAuth } from '../../../../AuthContext';

const STORES_PER_PAGE = 50;

const fetchAllStores = async () => {
  const stores = [];
  let page = 1;
  let lastPage = 1;
  do {
    const response = await api.get(EnterpriseEndpoints.merchants, { params: { perPage: STORES_PER_PAGE, page } });
    const envelope = response?.data?.data ?? {};
    stores.push(...(Array.isArray(envelope.data) ? envelope.data : []));
    lastPage = envelope.last_page ?? 1;
    page += 1;
  } while (page <= lastPage);
  return stores;
};

// A failure only hides the selector: the page's own request reports errors, deactivation included.
const useStores = () => {
  const { hasPermission } = useAuth();
  const enabled = hasPermission(Permissions.enterpriseMerchants);
  const [stores, setStores] = useState([]);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    fetchAllStores()
      .then((result) => {
        if (!cancelled) setStores(result);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return stores;
};

export default useStores;
